import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'catalogos/configuraciones-de-actualizador-de-carteras/';
export const baseURI2 = 'catalogos/tipos-de-cargos-configuraciones-de-actualizador/';
export const baseURI3 = 'recaudacion/actualizar-cartera-de-padron/';

/*
 * GET carteras
 * @returns {Promise<Array<object>>}
 */
export const getActCarteras = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET cartera
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getActCartera = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST cartera
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postActCartera = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * POST para actualizar cargos
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postActualizarCargos = async (values) => {
  try {
    const response = await API.post(baseURI3, values);
    onSuccess(response, 'Cargos actualizados correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH cartera
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchActCartera = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE cartera
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteActCartera = async (id) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, {
      estados_globales: 5,
    });
    onSuccess(response, 'Cancelado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * POST cartera
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCargos = async (values) => {
  const response = await API.post(baseURI2, values);
  return response.data;
};

/*
 * GET cargos
 * @returns {Promise<Array<object>>}
 */
export const getCargos = async (params = null) => {
  try {
    const response = await API.get(baseURI2, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};
